import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { EventsCalendar } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${EventsCalendar.Pages.CALENDAR}`,
    name: EventsCalendar.Pages.CALENDAR,
    component: () => import(/* webpackChunkName: "events-calendar" */ './views/EventsCalendar.vue'),
    meta: {
      access_roles: RouteRoles[EventsCalendar.Pages.CALENDAR],
    },
  },
];

export default routes;
